import { useEffect } from "react";

// The app's own name, as its index.html writes it ("Ghezaa Orders"), read once before any page changes it.
const appTitle = typeof document === "undefined" ? "" : document.title;

/**
 * The browser tab names the page, then the app: "Order inbox · Ghezaa Orders", "SBX-CP · Ghezaa Orders". `PageHeader`
 * does this with its title; a page without one calls this itself. Undefined (a record still loading) keeps the app's name.
 */
export function useDocumentTitle(title: string | undefined) {
  useEffect(() => {
    document.title = title ? `${title} · ${appTitle}` : appTitle;
    return () => {
      document.title = appTitle;
    };
  }, [title]);
}

/**
 * A specimen's name for the tab ("Requester specimen · Support"), kept while the whole pages it shows each name the tab
 * after their own record as they load.
 */
export function useSpecimenTitle(title: string) {
  useEffect(() => {
    const wanted = `${title} · ${appTitle}`;
    const keep = () => {
      if (document.title !== wanted) document.title = wanted;
    };
    const observer = new MutationObserver(keep);
    observer.observe(document.head, { subtree: true, childList: true, characterData: true });
    keep();
    return () => {
      observer.disconnect();
      document.title = appTitle;
    };
  }, [title]);
}
